<app-modal
  title="Edit Taxonomy"
  subtitle="Update this taxonomy's name and election type."
  (closed)="closed.emit()"
>
  <!-- Name -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Taxonomy Name</label>
    <input
      type="text"
      placeholder="Type name..."
      [value]="name()"
      (input)="name.set($any($event.target).value)"
      [class.border-red-400]="showErrors() && !name().trim()"
      [class.ring-2]="showErrors() && !name().trim()"
      [class.ring-red-100]="showErrors() && !name().trim()"
      class="w-full"
    />
    @if (showErrors() && !name().trim()) {
      <span class="text-2xs text-red-500">Required</span>
    }
  </div>

  <!-- Type (read-only) -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Classification Type</label>
    <div
      class="flex items-center gap-2 px-3 py-2.5 rounded-xl border border-surface-300 bg-slate-50"
    >
      <span
        class="inline-block px-2.5 py-0.5 rounded text-2xs font-semibold uppercase tracking-wide border"
        [ngClass]="
          type() === 'situation'
            ? 'border-accent-500 text-accent-500'
            : 'border-purple-50 bg-purple-10 text-purple-500'
        "
      >
        {{ type() === 'situation' ? 'Situation' : 'Response' }}
      </span>
      <span class="text-xs text-slate-400">Cannot be changed</span>
    </div>
  </div>

  <!-- Election type -->
  <div class="flex flex-col gap-1.5 mb-2">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Election Type</label>
    <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-1 gap-1">
      <button
        type="button"
        (click)="isMultiItem.set(true)"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          isMultiItem() ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'
        "
      >
        Multiple Choice
      </button>
      <button
        type="button"
        (click)="isMultiItem.set(false)"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          !isMultiItem() ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'
        "
      >
        Single Choice
      </button>
    </div>
  </div>

  <div modal-footer class="flex items-center justify-between gap-3 w-full">
    @if (confirmRemove()) {
      <div class="flex items-center gap-2">
        <span class="text-xs text-slate-500">Delete this taxonomy?</span>
        <button
          type="button"
          (click)="onRemove()"
          [disabled]="removing()"
          class="px-3 py-1.5 text-xs font-semibold text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ removing() ? 'Deleting...' : 'Confirm' }}
        </button>
        <button
          type="button"
          (click)="confirmRemove.set(false)"
          [disabled]="removing()"
          class="px-3 py-1.5 text-xs font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
      </div>
    } @else {
      <button
        type="button"
        (click)="onRemove()"
        class="flex items-center gap-1.5 text-xs font-semibold text-red-500 hover:text-red-600 transition-colors cursor-pointer"
      >
        <img src="/icons/trash-icon.svg" class="w-4 h-4" alt="" />
        Delete taxonomy
      </button>
    }

    <div class="flex items-center gap-3">
      <button
        type="button"
        (click)="closed.emit()"
        class="px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="submitting() || !hasChanges()"
        class="px-6 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {{ submitting() ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>
  </div>
</app-modal>
